module.exports = __webpack_public_path__ + "static/media/icon_mapa_green.7d25e437.svg";